import React, { useEffect, useRef, useCallback } from "react"
import Modal from "react-modal"

export const LuiUpdatesSplashModal: React.FC<{
  bigImage: string
  smallImage: string
  header: string
  onClose: () => void
  id: string
}> = (props) => {
  const node = useRef(null)

  // We have to do this as the CSS takes over a lot of the page
  // https://medium.com/@pitipatdop/little-neat-trick-to-capture-click-outside-with-react-hook-ba77c37c7e82
  const handleClickOutside = useCallback(
    (e: any) => {
      console.log("clicking anywhere")
      // current DOES have a contains!
      if (node?.current && (node.current as any).contains(e.target)) {
        // inside click
        return
      }
      // outside click
      props.onClose()
    },
    [props]
  )

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [handleClickOutside])

  if (process?.env?.NODE_ENV !== "test") {
    Modal.setAppElement("#root")
  }

  return (
    <Modal
      key={props.id}
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={props.onClose}
      contentLabel="Recent updates"
      className="lui-scrim"
    >
      <div ref={node} className="lui-large-feature-notification">
        <div className="lui-box-shadow">
          <div className="lui-feature-img lui-text-content-area">
            <h1>{props.header}</h1>
            <button aria-label="Close dialog" onClick={props.onClose}>
              <i className="material-icons-round">close</i>
            </button>
            <img className="lui-hide-xs lui-hide-sm" alt={"What's new"} src={props.bigImage} />
            <img className="lui-hide-md lui-hide-lg lui-hide-xl" alt={"What's new"} src={props.smallImage} />
          </div>
          <div className="lui-text-content-area">{props.children}</div>
        </div>
      </div>
    </Modal>
  )
}
